import { BaseRequestOptions, Headers, RequestOptions, RequestOptionsArgs } from '@angular/http';

export class RequestOptionsInterceptor extends BaseRequestOptions {

  constructor () {
    super();
  }

  merge(options? : RequestOptionsArgs) : RequestOptions {
    let user = JSON.parse(window.localStorage.getItem('currentUser'));
    let token = user ? user.authentication_token : null;
    let headers = token ? new Headers({ 'Auth-Token': token }) : new Headers({});
    options.headers = headers;
    return super.merge(options);
  }
}



// WEBPACK FOOTER //
// ./src/providers/request_options_interceptor.ts